import capitalize from 'lodash/capitalize';
import { toUnicode } from 'punycode.js';
import { retrieveCertificateConfiguration } from '@gandi/redux-resource-price';
import { TextPlaceholder } from '../../../../helpers';
import { getAddDiskDescription, getIsLegacy, getResizeDescription, getSubprocess } from './webhosting';
function getProtectTranslation({
  translator: {
    __
  },
  protect
}) {
  switch (protect) {
    case 'multi':
      return __('Multi addresses');
    case 'wildcard':
      return __('Full domain');
    case 'single':
    default:
      return __('Single address');
  }
}
function getProtectType({
  translator: {
    __
  },
  type
}) {
  switch (type) {
    case 'free':
      return __('SSL Free');
    case 'pro':
      return __('SSL Pro');
    case 'business':
      return __('SSL Business');
    case 'standard':
    default:
      return __('SSL Standard');
  }
}
export function getDescriptionLabel({
  translator,
  translator: {
    __
  },
  productType,
  payload = {},
  process,
  quantity = 1,
  identifier,
  label,
  prices
}) {
  if (productType === 'certificate' && payload.package) {
    const {
      type = '',
      protect = ''
    } = retrieveCertificateConfiguration(payload.package) || {};
    return `${getProtectType({
      translator,
      type
    })} - ${getProtectTranslation({
      translator,
      protect
    })}`;
  }
  if (productType === 'cloud') {
    return payload.isFirstServer ? __('Cloud Server %(name)s', {
      name: payload.extra?.name || ''
    }) : __('Cloud account');
  }
  if (productType === 'corporate' && process === 'create') {
    if (payload.contract_type === 'monthly') {
      return __('Corporate Services - %(count)s months', {
        count: payload.duration
      });
    }
  }
  if (productType === 'domain') {
    return payload.fqdn ? toUnicode(payload.fqdn) : identifier || '';
  }
  if (productType === 'domain_option' && payload.option === 'premium_dns') {
    return __('DNS security+ pack');
  }
  if (productType === 'mailbox-standalone') {
    if (process === 'create') {
      if (payload.config_name === 'premium') {
        return __('%(count)s Premium mailboxes 50 Go', {
          count: payload.quantity
        });
      }
      if (payload.config_name === 'standard') {
        return __('%(count)s Standard mailboxes 10 Go', {
          count: payload.quantity
        });
      }
    }
    if (process === 'renew' && identifier) {
      return identifier;
    }
  }
  if (productType === 'mailboxv2') {
    if (process === 'create') {
      if (payload.name !== undefined) return __('%(count)s %(name)s mailboxes', {
        count: quantity,
        name: payload.name
      });
      if (payload.mailbox_type === 'premium') {
        return __('%(count)s Legacy Premium mailboxes', {
          count: quantity
        });
      }
      if (payload.mailbox_type === 'standard') {
        return __('%(count)s Legacy Standard mailboxes', {
          count: quantity
        });
      }
    }
    if (process === 'renew') {
      return payload.email || payload.fqdn || '';
    }
    if (process === 'update') {
      return quantity === 1 ? __('Mailbox to 50 GB') : __('%(count)s mailbox to 50 GB', {
        count: quantity
      });
    }
  }
  if (productType === 'paas') {
    if (process === 'create' && !getIsLegacy(payload) && payload.label !== undefined) {
      return payload.label;
    }
    if (payload.extra?.application && typeof payload.size === 'string') {
      const size = payload.size ? `- ${payload.size.toUpperCase()}` : TextPlaceholder;
      return __('%(application)s instance %(size)s', {
        application: capitalize(payload.extra?.application || TextPlaceholder),
        size
      });
    }
    if (process === 'update') {
      const subprocess = getSubprocess(payload, prices || []);
      if (subprocess === 'add_disk') {
        return getAddDiskDescription({
          payload,
          translator
        }) || '';
      }
      if (subprocess === 'resize') {
        return getResizeDescription({
          payload,
          translator
        }) || payload.subProcessDescription || '';
      }
    }
    if (!!payload.size && typeof payload.size === 'string') {
      return __('Web Hosting - %(size)s', {
        size: payload.size.toUpperCase()
      });
    }
    if (prices && prices.length === 1) {
      const splitted = prices[0].description.split('_');
      if (splitted[1]) {
        return __('Web Hosting - %(size)s', {
          size: splitted[1].toUpperCase()
        });
      }
    }
    return __('Web Hosting');
  }
  if (productType === 'tmch') {
    return __('TMCH - %(brand)s', {
      brand: payload.mark_name || TextPlaceholder
    });
  }
  return payload.shopping?.label || payload.label || label || payload.fqdn || identifier || '';
}